/**
 * Display-time mask for legacy `?` characters that were originally bullets
 * but got flattened to `?` by VARCHAR storage. Restores those to `-` for
 * display only — the stored value is never changed.
 */
export function maskLegacyBulletDamage(text) {
    if (!text || typeof text !== "string") return text;

    // Optional: restore the single most common VARCHAR casualty — the curly
    // apostrophe (’ -> ?) — but ONLY inside known contractions/possessives,
    // where it is unambiguous. Remove this line to do bullets only.
    text = text.replace(/([A-Za-z])\?(t|s|re|ve|ll|m|d)\b/g, "$1'$2");

    return text.replace(/\?/g, (match, offset) => {
        const prevChar = text[offset - 1];
        const nextChar = text[offset + 1];

        const atBulletPosition = offset === 0 || /\s/.test(prevChar);
        if (!atBulletPosition) return match; // keep: questions, apostrophes, accents, URLs

        // "?-" was almost certainly "•-" / "• -": drop the "?", the dash stays.
        if (nextChar === "-") return "";

        // "?Word" with no separating space -> add one so it reads "- Word".
        if (nextChar && !/\s/.test(nextChar)) return "- ";

        // "? Word" / " ? " -> surrounding whitespace already separates.
        return "-";
    });
}

export default maskLegacyBulletDamage;
